module.exports = __webpack_public_path__ + "img/icon-password.28be7320.svg";